import { useState } from "react";
import { XIcon, DownloadIcon } from "lucide-react";
import { Button } from "./Buttons";

const TYPE_OPTIONS = [
  { value: "xlsx", label: "Excel File (.xlsx)" },
  { value: "json", label: "JSON Format" },
];

const ExcelExportModal = ({ open, onClose, onSubmit, loading = false }) => {
  const [type, setType] = useState("xlsx");

  if (!open) return null;

  const close = () => {
    setType("xlsx");
    onClose?.();
  };

  const submit = () => {
    onSubmit?.({ type, body: { type } });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white dark:bg-slate-800 shadow-xl">
        <div className="flex items-center justify-between border-b border-gray-200 dark:border-slate-700 px-4 py-3">
          <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">Export Data</h3>
          <button type="button" onClick={close} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <XIcon size={18} />
          </button>
        </div>

        <div className="space-y-4 p-4">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Export Format</label>
            <div className="mt-2 flex flex-col gap-2">
              {TYPE_OPTIONS.map((opt) => (
                <label key={opt.value} className="flex items-center gap-2 cursor-pointer text-sm text-gray-700 dark:text-gray-200">
                  <input
                    type="radio"
                    name="excel-export-type"
                    value={opt.value}
                    checked={type === opt.value}
                    onChange={() => setType(opt.value)}
                    className="text-green-500 focus:ring-green-400"
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 border-t border-gray-200 dark:border-slate-700 px-4 py-3">
          <Button type="button" onClick={close} className="!bg-gray-100 !text-gray-700 hover:!bg-gray-200 dark:!bg-slate-700 dark:!text-gray-200" disabled={loading}>
            Cancel
          </Button>
          <Button
            type="button"
            onClick={submit}
            icon={DownloadIcon}
            className="!bg-green-500 !text-white hover:!bg-green-600"
            disabled={loading}
            loading={loading}
            loadingText="Exporting..."
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExcelExportModal;
